<div class="top-panel-container display-flex">
  <div class="top-panel-content display-flex align-items-center">
    <app-icon
      class="logo-container"
      [ngClass]="{ 'show-logo': !isSidePanelExpanded }"
      tabindex="0"
      (click)="menuAction(MainPageActions.HOME_PAGE)"
      (keydown.enter)="menuAction(MainPageActions.HOME_PAGE)"
      [svg]="EIcon.LOGO"
      [iconHeight]="65"
      [iconWidth]="83"
    >
    </app-icon>
    <ng-container
      [ngTemplateOutlet]="dashboardViewType !== DashboardViewType.NONE ? propertySelector : breadcrumbs"
    ></ng-container>
    <div class="display-flex align-items-center grid-gap-16 right-section">
      <app-notification-ring *ngIf="userData?.id" [userId]="userData.id"></app-notification-ring>
      <div
        class="menu-section"
        [matMenuTriggerFor]="topBarMenu"
        (menuOpened)="toggleMenu(true)"
        (menuClosed)="toggleMenu(false)"
      >
        <ng-container
          [ngTemplateOutlet]="isAuthenticated ? loggedUserAvatarTemplate : notLoggedUserAvatarTemplate"
        ></ng-container>
      </div>
      <mat-menu #topBarMenu="matMenu" xPosition="before">
        <div class="top-panel-menu-list">
          <ng-container *ngIf="isAuthenticated">
            <button mat-menu-item class="text-centered body-small" (click)="menuAction(MainPageActions.LOGOUT)">
              Log out
            </button>
          </ng-container>
          <ng-container *ngIf="!isAuthenticated">
            <button mat-menu-item class="text-centered body-small" (click)="menuAction(MainPageActions.LOGIN)">
              Log in
            </button>
          </ng-container>
        </div>
      </mat-menu>
    </div>
  </div>
</div>

<ng-template #loggedUserAvatarTemplate>
  <app-avatar [userInfo]="userData" [containerCss]="'s-32'"></app-avatar>
</ng-template>

<ng-template #notLoggedUserAvatarTemplate>
  <app-avatar [icon]="EIcon.USER" [containerCss]="'s-32'"></app-avatar>
</ng-template>

<ng-template #breadcrumbs>
  <div class="display-flex align-items-center breadcrumb-container" [ngClass]="{ 'show-logo': !isSidePanelExpanded }">
    <button class="p-0" mat-button (click)="home()">
      <app-icon [svg]="EIcon.HOME" [iconColor]="EColorPalette.cGreen10" [iconHeight]="14" [iconWidth]="14"></app-icon>
    </button>
    <app-breadcrumb-item *ngFor="let item of breadcrumbList" [item]="item"></app-breadcrumb-item>
  </div>
</ng-template>

<ng-template #propertySelector>
  <app-property-selector></app-property-selector>
</ng-template>
